
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Sedancabserviceinpune() {



    const cardData =
    {
        keyword: ' Sedan Cab Service in Pune',
        heading: 'Prince Cabs: Sedan Cab Service in Pune',
        headingDescription: 'Prince Cabs provides comfortable Sedan Cab Service in Pune, ideal for local travel, corporate rides, airport transfers, and outstation journeys. Our fleet includes well-maintained sedans like Swift Dzire, Toyota Etios, and other premium models, ensuring a smooth, safe, and affordable ride. With professional chauffeurs, flexible booking options, and on-time pickups, we make every trip hassle-free. Choose Prince Cabs’ trusted sedan cab service in Pune for reliability, comfort, and value-for-money travel.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

  "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was once the grand seat of the Peshwas of the Maratha Empire. Though much of it was destroyed by fire in 1828, its massive gates, bastions, and sprawling courtyards still stand tall. The evening light-and-sound show narrates tales of Maratha valor, politics, and intrigue. Visitors enjoy exploring its ruins and imagining the fort’s glorious past. Shaniwar Wada is both a heritage treasure and a cultural icon of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is a magnificent structure associated with India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. Today, it houses a museum displaying artifacts and photographs of Gandhi’s life. Its lush gardens provide a serene retreat for visitors. Recognized as a national monument, the palace is a symbol of pride and sacrifice. It remains one of Pune’s most important landmarks."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress best known for the Battle of Sinhagad in 1670. The ruins, bastions, and memorials here narrate stories of Maratha valor. Trekkers enjoy the scenic climb, especially during monsoon when waterfalls and mist cover the hills. From the summit, panoramic Sahyadri views are breathtaking. Local food stalls serve pithla-bhakri, adding to the charm. It is a perfect blend of history, nature, and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious landmark, dedicated to Lord Ganesha. The idol is adorned with gold ornaments and attracts thousands of devotees every day. During Ganesh Chaturthi, the temple becomes the center of celebrations with grand decorations and cultural events. It is also known for its charitable work and community services. Its central location makes it easily accessible to visitors. The temple is a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill, one of Pune’s highest points, offers sweeping views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Visitors climb more than 100 steps to reach the peaceful temple complex. The Peshwa Museum nearby displays artifacts from Maratha history. Sunrises and sunsets from Parvati Hill are especially captivating. It is both a spiritual site and a popular city viewpoint."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum with a Shiva linga, and a stone-carved Nandi. Despite being in the city center, it offers a calm and meditative environment. The temple showcases Rashtrakuta-era architecture. Tourists admire its simplicity and historic value. It remains a hidden gem in Pune’s heritage landscape."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes musical instruments, sculptures, paintings, and everyday objects from across India. A highlight is the recreated Mastani Mahal. The museum reflects India’s artistic and cultural diversity. It fascinates both historians and art lovers. The heritage building itself adds to the charm. It is one of Pune’s most unique museums."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. People from across the globe come here for meditation, yoga, and wellness programs. Set amidst serene gardens, it offers a peaceful escape from city life. The ashram promotes holistic well-being and self-discovery. Its vibrant international community adds cosmopolitan charm. It is a unique blend of spirituality and modern lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity, located in Viman Nagar, is Pune’s largest lifestyle and shopping mall. It features hundreds of international and Indian brands, multiplex cinemas, gaming zones, and fine dining restaurants. Seasonal festivals and live events make it lively. Families and youngsters visit for shopping, leisure, and entertainment. It combines retail with culture in a modern setup. Phoenix Marketcity is Pune’s ultimate shopping hub."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a favorite picnic and weekend destination. Surrounded by hills, the reservoir supplies water to the city and offers scenic views. Families enjoy street food, boating, and evening walks here. During monsoon, the area becomes lush and vibrant. Cool breezes make it refreshing year-round. It is one of Pune’s most loved natural retreats."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by Mulshi Dam, is a scenic getaway near Pune. Surrounded by Sahyadri hills and forests, it is ideal for camping, boating, and nature walks. During monsoon, the valley comes alive with waterfalls and mist. Eco-resorts nearby make it a peaceful weekend escape. Photographers and trekkers love its natural beauty. Mulshi offers both relaxation and adventure close to Pune."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Located on Senapati Bapat Road, Chaturshringi Temple is one of Pune’s oldest shrines, dedicated to Goddess Chaturshringi. Devotees climb over 100 steps to reach the sanctum. The temple is vibrant during Navratri with colorful celebrations. Thousands of pilgrims visit throughout the year. Its hilltop location also offers scenic views of the city. It is an important spiritual and cultural site of Pune."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This war memorial honors Indian soldiers who sacrificed their lives post-independence. It showcases tanks, weapons, and war memorabilia. The museum narrates stories of India’s military history. Visitors attend the evening flag retreat ceremony, which is deeply inspiring. Families and students find it educational as well as patriotic. The memorial instills pride in the nation’s armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Spread over 39 acres, Empress Garden is a green paradise in the heart of Pune. Maintained by the Agri-Horticultural Society, it houses exotic trees, flower nurseries, and shaded walkways. Families enjoy picnics and play areas here. The annual flower show attracts gardening enthusiasts. With colonial-era history, it is one of Pune’s heritage gardens. It is a peaceful oasis away from urban chaos."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi is Pune’s highest hill and a favorite among trekkers, joggers, and cyclists. The hill offers stunning sunrise and sunset views over the city. It is home to diverse flora and fauna, making it a biodiversity hotspot. Locals use it for morning walks, yoga, and fitness. The hill’s fresh air and greenery make it Pune’s natural lungs. It is a refreshing retreat for nature lovers."
  }
],

"services": [
    {
        "name": "Sedan Taxi Service",
        "description": "Experience comfortable and reliable sedan taxi services ideal for city travel and short trips. Our sedan taxis offer smooth rides with well-maintained vehicles and professional drivers ensuring a safe and pleasant journey across Pune and nearby areas."
    },
    {
        "name": "Sedan Cab Service",
        "description": "Choose our sedan cab service for economical and efficient transportation. Perfect for individuals and small groups, our sedans provide spacious interiors, air-conditioning, and timely pickups, catering to daily commutes, business trips, and airport transfers."
    },
    {
        "name": "Sedan Cab",
        "description": "Book a sedan cab for hassle-free travel around Pune and nearby destinations. Whether it's for local sightseeing, airport drop, or intercity travel, our sedans offer comfortable seating for up to 4 passengers with professional drivers who prioritize your safety."
    },
    {
        "name": "Sedan Taxi Service Near Me",
        "description": "Find convenient and affordable sedan taxi services near your location in Pune. Our easy-to-book cabs offer prompt pickups, flexible booking options, and well-maintained vehicles to ensure smooth and comfortable rides anytime, anywhere."
    },
    {
        "name": "Sedan Taxi in Pune",
        "description": "Avail premium sedan taxi services in Pune with modern vehicles and courteous drivers. Ideal for airport transfers, business travel, and family outings, our sedans guarantee punctuality, comfort, and affordable fares tailored to your travel needs."
    },
    {
        "name": "Sedan Car Etios Taxi in Pune",
        "description": "Travel in style and comfort with Etios sedan taxis available in Pune. Known for fuel efficiency and smooth rides, Etios taxis are perfect for city travel, airport drop-offs, and outstation trips with competitive pricing and professional service."
    },
    {
        "name": "Swift Sedan Taxi Booking in Pune",
        "description": "Book Swift sedans for quick, reliable, and comfortable taxi rides within Pune. Our Swift sedans offer a balance of economy and convenience, suitable for solo travelers, couples, and small groups looking for affordable and timely cab services."
    },
    {
        "name": "Book Sedan Taxi",
        "description": "Easily book a sedan taxi online or via phone for any destination in and around Pune. Our seamless booking process ensures you get the best vehicle available, courteous drivers, and on-time service whether for airport transfers or local rides."
    },
    {
        "name": "Affordable Sedan Cab in Pune",
        "description": "Opt for our affordable sedan cab options in Pune, offering great value without compromising comfort or safety. Ideal for budget-conscious travelers who want a clean, reliable, and timely taxi experience across the city and nearby areas."
    },
    {
        "name": "Luxury Sedan Car Rental Pune",
        "description": "Upgrade your travel experience with luxury sedan car rentals in Pune. Perfect for corporate clients, weddings, and special occasions, our premium sedans provide elegant interiors, smooth rides, and professional chauffeurs to cater to your sophisticated needs."
    },
    {
        "name": "Sedan Cab Hire for Outstation",
        "description": "Plan your outstation trips with our sedan cab hire services. Whether heading to Mumbai, Lonavala, or other nearby destinations, our sedans offer comfortable seating, affordable fares, and reliable drivers for a hassle-free long-distance journey."
    },
    {
        "name": "Pune Airport Sedan Taxi Service",
        "description": "Get timely and convenient sedan taxi service to and from Pune airport. Our airport transfer service includes flight tracking, door-to-door pickups, and spacious vehicles ensuring a stress-free start or end to your travel."
    },
    {
        "name": "Best Sedan Cab in Pune",
        "description": "Choose the best sedan cab service in Pune featuring modern cars, experienced drivers, and customer-focused service. Our commitment to quality ensures a comfortable, safe, and punctual ride for every trip you take."
    },
    {
        "name": "Sedan Cab Pune to Mumbai",
        "description": "Travel comfortably from Pune to Mumbai with our sedan cab service. Enjoy affordable fares, comfortable seating for up to 4 passengers, and professional drivers familiar with the route for a smooth intercity experience."
    },
    {
        "name": "4 Seater Sedan Cab Booking",
        "description": "Book a 4-seater sedan cab ideal for small groups or families needing reliable transport within Pune or for outstation trips. Our sedans provide ample space, air-conditioning, and prompt service ensuring a pleasant journey."
    }
],
"tableData": [
    ["Sedan Taxi Service", "Sedan Cab Service"],
    ["Sedan Cab", "Sedan Taxi Service Near Me"],
    ["Sedan Taxi in Pune", "Sedan Car Etios Taxi in Pune"],
    ["Swift Sedan Taxi Booking in Pune", "Book Sedan Taxi"],
    ["Affordable Sedan Cab in Pune", "Luxury Sedan Car Rental Pune"],
    ["Sedan Cab Hire for Outstation", "Pune Airport Sedan Taxi Service"],
    ["Best Sedan Cab in Pune", "Sedan Cab Pune to Mumbai"],
    ["4 Seater Sedan Cab Booking", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Sedan Cab Service in Pune",
        "WhyChoosedescription": "Prince Cabs offers dependable sedan cab services across Pune, ideal for business travelers, solo commuters, couples, and small groups. Our fleet includes well-maintained sedans like Swift Dzire, Honda City, and Toyota Etios, ensuring you get a comfortable and smooth ride for airport transfers, city commutes, and outstation trips."
    },
    {
        "WhyChooseheading": "Comfortable and Stylish Sedans",
        "WhyChoosedescription": "Our sedans feature plush seating, spacious legroom, and climate control systems that make your journey relaxing regardless of traffic or weather. Clean interiors and modern amenities such as charging ports and music systems enhance your overall travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Knowledge",
        "WhyChoosedescription": "Our professional drivers have extensive knowledge of Pune’s routes and traffic patterns, ensuring punctual pickups and safe, courteous driving. They are trained to provide excellent customer service and assist you with luggage and route preferences."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Suit Your Needs",
        "WhyChoosedescription": "Whether you need a sedan cab for a quick city ride, airport transfer, or a longer outstation journey, Prince Cabs offers hourly, half-day, full-day, and multi-day rental packages. Book easily through phone, WhatsApp, or our online portal with instant confirmation."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We provide clear and competitive pricing with no surprises. Our fare structure includes all taxes, tolls, and driver allowances. Multiple secure payment methods like UPI, credit/debit cards, net banking, and cash are accepted for your convenience."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "Each sedan cab is thoroughly sanitized before and after every trip to ensure passenger safety. Our vehicles undergo regular maintenance and safety checks, equipped with seat belts and essential safety features for your peace of mind."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist you with bookings, route changes, and any queries, ensuring a smooth and worry-free travel experience with Prince Cabs."
    }
]





















    }

const faqData = [
    {
        question: 'Does Prince Cabs provide sedan cab services in Pune?',
        answer: 'Yes, Prince Cabs offers premium sedan cab services across Pune, ideal for airport transfers, business travel, and local commuting.',
    },
    {
        question: 'What types of sedans are available for hire in Pune?',
        answer: 'We provide a range of sedans including Toyota Etios, Honda City, Hyundai Verna, and other well-maintained models for comfortable travel.',
    },
    {
        question: 'Can I book a sedan cab for airport pickups and drop-offs?',
        answer: 'Absolutely! Our sedan cabs are perfect for timely airport transfers with professional drivers ensuring a smooth experience.',
    },
    {
        question: 'How do I book a sedan cab in Pune with Prince Cabs?',
        answer: 'You can book easily via our website or by calling our customer support. Just provide your pickup location, destination, and travel time.',
    },
    {
        question: 'Are the sedan cabs clean and well-maintained?',
        answer: 'Yes, all our sedans undergo regular servicing and sanitation to ensure a safe and comfortable journey for all passengers.',
    },
    {
        question: 'Are the drivers experienced and verified?',
        answer: 'Yes, our drivers are professionally trained, background-verified, and committed to providing courteous and safe service.',
    },
    {
        question: 'What are the charges for sedan cab service in Pune?',
        answer: 'Charges vary based on distance, time, and type of sedan chosen. Contact Prince Cabs for a customized and competitive quote.',
    },
];

const testimonials = [
    {
        name: "Mr. Rohan Desai",
        position: "Business Traveler",
        text: "I regularly use Prince Cabs’ sedan service in Pune. The cars are clean, the drivers punctual, and the service is always reliable.",
        image: "/img/testimonial/testimonial-thumb-sedan-1.png",
    },
    {
        name: "Ms. Neha Kulkarni",
        position: "Airport Commuter",
        text: "Booked a sedan for airport drop-off, and the experience was seamless. Comfortable ride and professional driver. Highly recommend Prince Cabs!",
        image: "/img/testimonial/testimonial-thumb-sedan-2.png",
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Sedan Cab Service in Pune",
  "description": "Reliable and affordable sedan taxi service in Pune. Book Swift, Etios, and other 4-seater sedan cabs for local rides, airport transfers, and outstation trips.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Sedan Taxi Service",
    "Sedan Cab Service",
    "Airport Sedan Taxi",
    "Outstation Sedan Cab"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Sedan Cab Service in Pune | Affordable Sedan Taxi Booking</title>
  <meta
    name="description"
    content="Reliable and affordable sedan taxi service in Pune. Book Swift, Etios, and other 4-seater sedan cabs for local rides, airport transfers, and outstation trips."
  />
  <meta
    name="keywords"
    content="Sedan Taxi Service, Sedan Cab Service, Sedan Cab, Sedan Taxi Service Near Me, Sedan Taxi in Pune, Sedan Car Etios Taxi in Pune, Swift Sedan Taxi Booking in Pune, Book Sedan Taxi, Affordable Sedan Cab in Pune, Luxury Sedan Car Rental Pune, Sedan Cab Hire for Outstation, Pune Airport Sedan Taxi Service, Best Sedan Cab in Pune, Sedan Cab Pune to Mumbai, 4 Seater Sedan Cab Booking"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedancabserviceinpune ;